import { render, staticRenderFns } from "./activities-today.vue?vue&type=template&id=3aa9e532&"
import script from "./activities-today.vue?vue&type=script&lang=js&"
export * from "./activities-today.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports